module.exports = __webpack_public_path__ + "static/media/pla_cra_cor.52810243.png";